export default __webpack_public_path__ + "static/The Backdrop_image 1@2x-98464b86412ad0b4d1efae9d8a2b1a98.jpg";